<template>
    <div>
        <!-- < Top -->
        <ae-block>
            <home-top-coach
                    :indicators="home.top"
            />
        </ae-block>
        <!-- > Top -->
        <!-- < Next Meeting -->
        <ae-block>
            <home-middle-meeting
                    v-if="home.meetings.length > 0"
                    :meeting="home.meetings[0]"
                    class="w-100 h-100"
            />
            <home-placeholder
                    v-else
                    target="meetings"
            />
        </ae-block>
        <!-- > Next Meeting -->
        <!-- < News -->
        <ae-block>
            <home-middle-news
                    v-if="home.news.length > 0"
                    :element="home.news[0]"
            />
        </ae-block>
        <!-- > News -->
        <!-- < Reminders -->
        <ae-block
                class="d-flex flex-column justify-content-around home--block bg-whitesmoke"
        >
            <h5 class="font-weight-bold text-primary text-center my-1">
                <i class="fas fa-bullhorn"></i>
                Rappels
            </h5>
            <home-bottom-reminder
                    v-for="(todo, i) of reminders(4)"
                    :key="`home-coach-todo-list-${i}`"
                    :reminder="todo"
            />
            <div v-if="reminders(4).length === 0">
                <p class="text-center my-0 text-muted">Vous n'avez aucune tâche à effectuer</p>
            </div>
        </ae-block>
        <!-- > Reminders -->
    </div>
</template>

<script>
    import AeBlock from "../../Block";
    import HomeTopCoach from "../top/Coach";
    import HomeMiddleMeeting from "../middle/Meeting";
    import HomePlaceholder from "../Placeholder";
    import HomeMiddleNews from "../middle/News";
    import HomeBottomReminder from "../bottom/Reminder";

    export default {
        name: 'home-mobile-coach',
        components: {HomeBottomReminder, HomeMiddleNews, HomePlaceholder, HomeMiddleMeeting, HomeTopCoach, AeBlock},
        computed: {
            home() {
                return this.$store.state.base.appInterface.home
            },
            user() {
                return this.$store.state.base.account.information
            },
            hasRoleWorker() {
                return this.$store.getters['base/account/getIsWorker'](this.user)
            },
            hasRoleCoach() {
                if (!this.user) return false
                return this.$store.getters['base/account/getIsCoach'](this.user)
            },
            hasRoleRelais() {
                return this.$store.getters['base/account/getIsWorkerRelais'](this.user)
            },
            hasRoleReferent() {
                return this.$store.getters['base/account/getIsCoachReferent'](this.user)
            },
        },
        methods: {
            async update() {
                await this.$store.dispatch('base/appInterface/home')
            },
            reminders(limit) {
                return this.home.timeline.filter((t) => {
                    return t.type === 'coach_todo'
                }).splice(0, limit).map((t) => {
                    return t.element
                })
            }
        }
    }
</script>
